var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49992 0.083252L2.52075 4.95825H8.47909L5.49992 0.083252Z",
    fill: "url(#paint0_linear_758_19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47925 10.9167C9.82544 10.9167 10.9167 9.82544 10.9167 8.47925C10.9167 7.13305 9.82544 6.04175 8.47925 6.04175C7.13305 6.04175 6.04175 7.13305 6.04175 8.47925C6.04175 9.82544 7.13305 10.9167 8.47925 10.9167Z",
    fill: "url(#paint1_linear_758_19)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 6.3125H4.95833V10.6458H0.625V6.3125Z",
    fill: "url(#paint2_linear_758_19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_758_19",
    x1: 5.49992,
    y1: 0.083252,
    x2: 5.49992,
    y2: 4.95825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22201"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_758_19",
    x1: 8.47925,
    y1: 6.04175,
    x2: 8.47925,
    y2: 10.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22201"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_758_19",
    x1: 2.79167,
    y1: 6.3125,
    x2: 2.79167,
    y2: 10.6458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22201"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN2);
export default __webpack_public_path__ + "static/media/n2.aaf59a987dc896b4324617e06f5fbf88.svg";
export { ForwardRef as ReactComponent };